import Vue from 'vue'
export const eventBus = new Vue()
export const busEmit = (eventName, message, data) => {
  eventBus.$emit(eventName, { detail: { message: message, data: data } })
}
